import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CollaborationRequestVM } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const retrieveCollaborationRequestList = createAsyncThunk<CollaborationRequestVM[], void, { extra: Partial<Dependencies> }>(
  "collaborationRequests/retrieveCollaborationRequestList",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.listCollaborationRequests();
  },
);
